import { makeObservable, observable } from 'mobx';
import { SubmissionVsUnderwritingBaseStore } from './submissionVsUnderwritingBaseStore';

export class SubmissionVsUnderwritingStore extends SubmissionVsUnderwritingBaseStore {

  globalStore;
  loanStore;
  loanDetails;
  constructor(
    globalStore, loanStore
  ) {
    super(globalStore, loanStore);
    makeObservable(this, {
      loanDetails: observable,
    });
  }

  *getSubmissionVsUnderwriting(loanId, loanDetails) {
    this.loanDetails = loanDetails;
  }

  reset() {
    // No reset logic required yet.
  }


  get amount() {
    return this.loanDetails?.amount;
  }

  get rate() {
    return this.loanDetails?.rate;
  }

  get initialLoanAmount() {
    return this.loanDetails?.initialLoanAmount;
  }

  get constructionHoldback() {
    return this.loanDetails?.constructionHoldback;
  }

  get aggregateLoanToAsIs() {
    return this.loanDetails?.aggregateLoanToAsIs;
  }

  get primaryProperty() {
    return this.loanDetails?.primaryProperty;
  }

  get loanSubtype() {
    return this.loanDetails?.loanSubtype;
  }

  get calculatedLoanData() {
    return {
      ...this.loanDetails?.calculatedLoanData,
      currentBorrowersNames: this.loanDetails?.borrowerNames?.slice().sort((a, b) => a.localeCompare(b)),
      currentInternalValue: this.loanDetails?.propertiesMap?.rows?.reduce((acc, row) => acc + (row.internalValue ?? 0), 0),
    }
  }

  get loanComparisonValues() {
    return this.loanDetails?.loanComparisonValues;
  }

}

export default SubmissionVsUnderwritingStore;
